module.exports = __webpack_public_path__ + "static/media/estate-clarity-mockup-3.532991c3.jpg";